import { createContext } from 'react';

interface CompositeAria {
  'aria-describedby'?: string;
}

export const CompositeAriaContext = createContext<CompositeAria>({});
